export function syncThemeChrome() {
  const html = document.documentElement;
  const dark = html.classList.contains("dark");
  const tv = html.classList.contains("tv-mode");
  html.style.colorScheme = dark ? "dark" : "light";
  const canvas = getComputedStyle(html).getPropertyValue("--c-canvas").trim();
  const color = tv ? "#000000" : canvas || (dark ? "#171D27" : "#F3F6FA");
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", color);
}
